export default "__VITE_ASSET__BmjFcifa__"